// @mui
import { Box, BoxProps, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

export default function WelcomeIllustration({ ...other }: BoxProps) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  return (
    <Box {...other}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width="100%"
        height="100%"
        viewBox="0 0 480 360"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M622.7107,251.78146c21.62346-15.9736,52.06689-22.09715,75.88747-9.63549A123.86323,123.86323,0,0,0,636.96,300.7345c-4.97231,10.11919-9.44907,21.8919-19.70824,26.5687-6.38345,2.91015-13.91747,2.34819-20.52752-.00156-6.61031-2.35-12.49027-6.34193-18.28842-10.29169l-1.73878-.20932C587.01552,291.97609,601.08724,267.75506,622.7107,251.78146Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#f0f0f0"
        />
        <path
          d="M698.40645,242.67649a105.86975,105.86975,0,0,0-61.32075,21.9692,45.59143,45.59143,0,0,0-9.99022,10.21,26.14853,26.14853,0,0,0-4.31106,13.0692c-.31513,4.3434-.1345,8.82271-1.5,13.01386a16.01079,16.01079,0,0,1-8.93551,9.5713c-5.12545,2.31655-10.7776,2.65328-16.31638,2.7905-6.14976.15235-12.53985.21316-18.13271,3.10887-.67765.35086-1.18244-.72114-.50581-1.07147,9.73062-5.038,21.10151-1.751,31.32866-4.74939,4.77218-1.39912,9.15162-4.24487,11.06774-9.00614,1.67556-4.16352,1.49324-8.78279,1.77431-13.18333a27.90257,27.90257,0,0,1,3.73915-12.93592,42.1479,42.1479,0,0,1,9.56083-10.55644,102.71252,102.71252,0,0,1,27.79317-16.0653,107.747,107.747,0,0,1,35.85258-7.34544c.76021-.02358.6512,1.157-.104,1.18048Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M642.50292,259.93723a15.88385,15.88385,0,0,1,3.73161-20.22656c.59245-.47977,1.36582.41833.77259.89873a14.70808,14.70808,0,0,0-3.43272,18.822c.38315.65915-.69051,1.16119-1.07148.50581Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M622.65416,285.7016a30.6148,30.6148,0,0,0,22.19878-2.23674c.67887-.34844,1.18386.72345.50581,1.07148a31.844,31.844,0,0,1-23.10457,2.28056c-.73512-.20776-.33115-1.32194.4-1.1153Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M674.04613,245.93647a8.991,8.991,0,0,0,6.18323,5.87817c.73739.19834.33261,1.31236-.4,1.11531a10.07519,10.07519,0,0,1-6.85472-6.48767.61234.61234,0,0,1,.28283-.78864.59543.59543,0,0,1,.78864.28283Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M717.48461,331.18753c-.464-.11075-.92792-.2215-1.39947-.32571a118.40667,118.40667,0,0,0-18.99746-2.83141c-.49419-.04093-.99563-.075-1.49-.10162a124.8269,124.8269,0,0,0-45.57546,5.91413,121.22208,121.22208,0,0,0-17.02746,7.02206c-7.581,3.82469-15.49651,8.57481-23.65806,9.64035a20.79642,20.79642,0,0,1-2.56581.20343L576.57653,318.9381c-.03238-.10664-.07232-.20678-.105-.31377l-1.26357-1.21338c.27314-.16259.55993-.32535.83307-.48794.15806-.095.32284-.18287.48089-.27785.1075-.06107.21538-.12183.30889-.18309.03571-.02046.07175-.04057.10024-.05418.09352-.06125.18689-.10823.27315-.16259q2.40082-1.37131,4.8293-2.71366c.00725-.00689.00725-.00689.02123-.00671,12.35321-6.78717,25.38157-12.60268,38.87843-16.25585.40611-.10977.81914-.2268,1.239-.32206a115.67343,115.67343,0,0,1,18.58152-3.32562,102.26163,102.26163,0,0,1,10.33807-.43015,85.03674,85.03674,0,0,1,26.21384,4.44385c16.84592,5.67712,31.68868,16.67867,39.5873,32.34924C717.09467,330.38536,717.29009,330.77962,717.48461,331.18753Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#f0f0f0"
        />
        <path
          d="M717.0135,331.49934a105.86972,105.86972,0,0,0-62.18816-19.37815,45.591,45.591,0,0,0-14.12377,2.13732,26.14842,26.14842,0,0,0-11.3107,7.83948c-2.86664,3.27822-5.41927,6.96345-9.03288,9.48775a16.01083,16.01083,0,0,1-12.89709,2.26236c-5.4871-1.23625-10.20277-4.37037-14.70779-7.59554-5.002-3.58094-10.1407-7.37966-16.34971-8.43488-.7523-.12785-.50993-1.2877.24124-1.16,10.80261,1.8359,17.90259,11.30651,27.87365,15.06989,4.65268,1.75606,9.86276,2.12062,14.25928-.52736,3.84457-2.31553,6.48012-6.11353,9.354-9.45789a27.90257,27.90257,0,0,1,10.77383-8.07738,42.14776,42.14776,0,0,1,13.98949-2.67244,102.71233,102.71233,0,0,1,31.86371,3.90616,107.747,107.747,0,0,1,33.04874,15.72081c.62118.43887-.17668,1.3159-.7938.87991Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M661.9855,311.62329a15.88384,15.88384,0,0,1,15.15727-13.90309c.76189-.02638.83867,1.15632.07577,1.18273a14.70807,14.70807,0,0,0-14.073,12.9616c-.09093.757-1.25045.51141-1.16-.24124Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M630.62545,320.24436a30.61485,30.61485,0,0,0,19.07115,11.5793c.75183.13051.50968,1.2904-.24124,1.16a31.844,31.844,0,0,1-19.82077-12.08964c-.46186-.60848.5315-1.25487.99086-.6497Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M695.60041,319.43566a8.991,8.991,0,0,0,1.3979,8.41611c.46935.60233-.52456,1.2481-.99086.64969a10.07517,10.07517,0,0,1-1.56708-9.307.61235.61235,0,0,1,.70064-.45941.59543.59543,0,0,1,.4594.70065Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M617.00532,275.54539h-2.33989V211.44461a37.09977,37.09977,0,0,0-37.09975-37.09981H441.75945a37.09978,37.09978,0,0,0-37.09986,37.0997V563.10644a37.0998,37.0998,0,0,0,37.09975,37.09982H577.5655a37.09979,37.09979,0,0,0,37.09989-37.09968V321.17342h2.33993Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#3f3d56"
        />
        <path
          d="M579.06253,183.99688h-17.7272a13.16294,13.16294,0,0,1-12.18707,18.1342H471.34663a13.16289,13.16289,0,0,1-12.18706-18.13422H442.60232a27.70572,27.70572,0,0,0-27.70573,27.70567V562.84847a27.70571,27.70571,0,0,0,27.70569,27.70573H579.06253a27.7057,27.7057,0,0,0,27.70572-27.70569h0v-351.146A27.70569,27.70569,0,0,0,579.06253,183.99688Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#fff"
        />
        <path
          d="M513.45449,477.75275a76.42878,76.42878,0,0,1-76.5-76.5,76.38991,76.38991,0,0,1,41.7583-68.166,76.65655,76.65655,0,0,1,59.40674-4.26367,76.50962,76.50962,0,0,1-24.665,148.92969Zm0-150a72.68935,72.68935,0,0,0-33.37769,8.00586,73.502,73.502,0,1,0,76.42774,125.05957,72.8468,72.8468,0,0,0,10.95654-9.72168,73.474,73.474,0,0,0-54.00659-123.34375Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#f0f0f0"
        />
        <path
          d="M347.69027,333.36145a14.47588,14.47588,0,0,1,12.0229,18.65894l25.41716,21.17171L376.03158,391.776l-35.474-30.40269a14.5543,14.5543,0,0,1,7.13273-28.01189Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#ffb6b6"
        />
        <path
          d="M585.0746,421.65265c-.50976-5.47961-2.61718-15.33026-4.40527-18.9726-5.49707-14.38787-41.01514-26.21295-45.78467-27.73736l-1.21-13.45-49.3501-5.31-6.26025,17.2-17.69971,6.64a8.693,8.693,0,0,0-5.18017,5.31h0l-15.87988,4.59-15.66993,4.53-54.43994-38.36-2.57031,1.68-17.17969,11.21-2.65039,1.73,70.4502,63.56,26.16992-6.14,19.68017-4.63,1.67969,6.82-4.34961,23.96a74.97706,74.97706,0,0,0,96.96,7.75l11.17969-9.92a74.88917,74.88917,0,0,0,16.81006-29.53Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#e4e4e4"
        />
        <circle
          cx="513.33775"
          cy="311.4487"
          r="35.53244"
          transform="matrix(0.94932, -0.31431, 0.31431, 0.94932, -345.96993, 2.78906)"
          fill="#ffb6b6"
        />
        <path
          d="M485.27061,270.9435a23.983,23.983,0,0,1,14.5216-9.67278,22.8969,22.8969,0,0,1,16.88507,3.09712c5.452-2.19621,11.33029-3.6533,17.10563-2.91256s11.43572,3.96667,14.10807,9.28129a25.37375,25.37375,0,0,0,2.03827,3.95869c2.35454,3.14113,6.72971,3.54858,10.59381,3.69946q-2.93021,1.70916-5.86165,3.41809,2.92087,1.361,5.84236,2.72228-3.9758,1.51758-7.951,3.03528c6.16847,5.42231,7.66063,15.07227,5.32458,23.16276-2.21112,7.65987-7.281,14.108-12.94234,19.62844-1.10458-4.11918.11052-8.585.91956-12.84962.85442-4.50607.99132-9.775-2.1637-12.95635-2.12834-2.146-5.25043-2.79434-8.19419-3.315a397.68841,397.68841,0,0,0-44.88637-5.32972,12.6995,12.6995,0,0,0-5.98288.61092c-3.66278,1.6276-5.13441,6.09753-6.19581,10.06093a79.77531,79.77531,0,0,1,1.20815-20.80159C480.64386,280.53748,482.22559,275.28913,485.27061,270.9435Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#2f2e41"
        />
        <path
          d="M531.45449,513.79523h-42a5.5,5.5,0,0,1,0-11h42a5.5,5.5,0,0,1,0,11Z"
          transform="translate(-274.09365 -174.3448)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M393.63613,219.47H278.11147a4.01807,4.01807,0,0,1,0-8.03613H393.63613a4.01806,4.01806,0,0,1,0,8.03613Z"
          transform="translate(-274.09365 -174.3448)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M460.33632,245.13312H278.11147a4.01782,4.01782,0,0,1,0-8.03565H460.33632a4.01782,4.01782,0,1,1,0,8.03565Z"
          transform="translate(-274.09365 -174.3448)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M425.3185,269.31036h-147.207a4.01782,4.01782,0,1,1,0-8.03564h147.207a4.01782,4.01782,0,1,1,0,8.03564Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#cacaca"
        />
        <path
          d="M361.1205,293.39874h-83.009a4.01782,4.01782,0,1,1,0-8.03564h83.009a4.01782,4.01782,0,1,1,0,8.03564Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#cacaca"
        />
        <path
          d="M406.97646,317.48517h-128.865a4.01783,4.01783,0,0,1,0-8.03565h128.865a4.01783,4.01783,0,0,1,0,8.03565Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#cacaca"
        />
        <polygon
          points="496.06 536.227 485.706 536.226 480.78 496.288 496.062 496.289 496.06 536.227"
          fill="#9f616a"
        />
        <path
          d="M774.22738,724.90117l-39.53077-.00146v-.5a15.3873,15.3873,0,0,1,15.38648-15.38623h.001l7.22081-5.47809,13.47243,5.47892,3.4508.00014Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#2f2e41"
        />
        <path
          d="M764.12069,522.87135,759.554,467.19223l-3.58744-20.89863,20.08575-4.436,6.6653,28.61144-5.80708,53.94739a9.29014,9.29014,0,1,1-12.78982-1.5451Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#9f616a"
        />
        <polygon
          points="441.06 536.227 430.706 536.226 425.78 496.288 441.062 496.289 441.06 536.227"
          fill="#9f616a"
        />
        <path
          d="M698.58316,535.4935l-4.59012,7.9401s-5.04362,1.37761-3.39527,17.81863,1.7194,113.84966,9.69817,125.836l1.44353,10.2929,15.06687,1.43981.37991-9.13288,17.96536-126.88429s10.58087,124.56,19.33381,127.60789l3.16116,10.37754,13.80791.006-.81518-12.22931.89025-154.35932Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#2f2e41"
        />
        <path
          d="M693.5366,542.82854l-.31746-.08165c9.47412-35.4364,6.74121-81.32324.05175-130.5968l.00013-.20413,24.18347-22.15073h21l20.81805,13.43484c13.45859,6.729,16.51709,20.97916,16.54647,21.12267l.02072.10145-8.24627,28.78406,6.21226,83.24318.00711.0965-.03547.0899c-2.01051,5.09757-7.39808,4.37176-13.63632,3.53089-6.22742-.83963-29.176,6.83827-36.21267,6.83827C710.17719,547.037,694.51912,543.08051,693.5366,542.82854Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#e4e4e4"
        />
        <path
          d="M754.913,414.44928l9.0214-3.9246,11.88592,14.57286,9.63418,46.69769-33-5Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#e4e4e4"
        />
        <path
          d="M616.1535,500.56024l41.241-37.68555,14.333-15.62653L687.52762,460.419,668.97826,483.1997,622.75846,511.621a9.29014,9.29014,0,1,1-6.605-11.0608Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#9f616a"
        />
        <path
          d="M656.49652,463.28489l11.42238-14.83331c.09458-.21272,9.57143-21.39,17.78572-30.59133,8.42632-9.43894,15.06009-4.6119,15.12636-4.55987l.16511.12439.4584,34.85653-31.62778,37.79188Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#e4e4e4"
        />
        <circle
          cx="725.87157"
          cy="365.84746"
          r="19.25073"
          transform="translate(-25.61731 849.39908) rotate(-80.78252)"
          fill="#9f616a"
        />
        <path
          d="M708.27224,362.98972s-.15412-6.76763-1.00978-9.76219-2.56676-5.56132-1.71118-5.56132,1.28338-2.139,1.28338-2.139.85557-.42778,1.28338,0,.85557-2.99455.85557-2.99455.42781-1.28338.85557-.42778.42781.42778.85558-.8556,2.56689-2.139,2.56689-2.139,8.12809.42778,9.41147-1.28338,15.82838-.4278,18.82295,1.71116,16.25619,9.83927,14.11719,16.25619-8.29628,21.19177-9.83928,22.6731c-2.43993,2.34242-4.12908,3.187-15.67422,5.48425-2.25944.44959-13.79216-6.92591-13.79216-8.20929s1.39036-5.35331-.84458-5.912c-3.37831-.84458-3.75836,3.42648-4.614,2.1431S708.27224,362.98972,708.27224,362.98972Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#2f2e41"
        />
        <path
          d="M719.22738,724.90117l-39.53077-.00146v-.5a15.3873,15.3873,0,0,1,15.38648-15.38623h.001l7.22081-5.47809,13.47243,5.47892,3.4508.00014Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#2f2e41"
        />
        <path
          d="M924.71567,725.6552h-647.294a1.19068,1.19068,0,1,1,0-2.38136h647.294a1.19068,1.19068,0,0,1,0,2.38136Z"
          transform="translate(-274.09365 -174.3448)"
          fill="#cacaca"
        />
      </svg>
    </Box>
  );
}
